export enum Region {
  usa = "USA",
  uk = "UK",
  both = "Both",
}
